var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88699 4L10.0003 6.10667V6C10.0003 5.46957 9.78961 4.96086 9.41454 4.58579C9.03947 4.21071 8.53076 4 8.00033 4H7.88699ZM5.02033 4.53333L6.05366 5.56667C6.02033 5.70667 6.00033 5.84667 6.00033 6C6.00033 6.53043 6.21104 7.03914 6.58611 7.41421C6.96118 7.78929 7.46989 8 8.00033 8C8.14699 8 8.29366 7.98 8.43366 7.94667L9.46699 8.98C9.02033 9.2 8.52699 9.33333 8.00033 9.33333C7.11627 9.33333 6.26842 8.98214 5.6433 8.35702C5.01818 7.7319 4.66699 6.88406 4.66699 6C4.66699 5.47333 4.80033 4.98 5.02033 4.53333ZM1.33366 0.846667L2.85366 2.36667L3.15366 2.66667C2.05366 3.53333 1.18699 4.66667 0.666992 6C1.82033 8.92667 4.66699 11 8.00033 11C9.03366 11 10.0203 10.8 10.9203 10.44L11.207 10.72L13.1537 12.6667L14.0003 11.82L2.18033 0M8.00033 2.66667C8.88438 2.66667 9.73223 3.01786 10.3573 3.64298C10.9825 4.2681 11.3337 5.11595 11.3337 6C11.3337 6.42667 11.247 6.84 11.0937 7.21333L13.047 9.16667C14.047 8.33333 14.847 7.24 15.3337 6C14.1803 3.07333 11.3337 1 8.00033 1C7.06699 1 6.17366 1.16667 5.33366 1.46667L6.78033 2.9C7.16033 2.75333 7.56699 2.66667 8.00033 2.66667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.669eb005260138693a5c72ca2b53fdcd.svg";
export { ForwardRef as ReactComponent };